export const jobs = {
    id: 1,
    jobTitle: "Content creator",
    price: 0.3,
    tags: ["Project Management", "Soft skills", "Time Management"],
    description: 'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Accusamus, ex numquam neque assumenda maxime sint quis quos dolorem hic similique enim saepe harum expedita sed dolore nam maiores earum veritatis.',
    status: 'open',
    paidout: false,
}
